document.addEventListener('DOMContentLoaded', function () {
	for (let element of document.querySelectorAll('[data-feature-list] [data-accordion-heading]')) {
		element.addEventListener('click', toggleFeatureComparison);
	}
});
window.toggleFeatureComparisonExpansion = toggleFeatureComparisonExpansion;

function toggleFeatureComparison(event) {
	let line = event.target.closest('[data-accordion-selected]');
	let selected = line.getAttribute('data-accordion-selected');

	// to make sure only one is open at a time, close all others first
	for (let others of document.querySelectorAll('[data-accordion-selected="true"]')) {
		others.setAttribute('data-accordion-selected', false);
	}

	// in any case, invert value of currently clicked element
	line.setAttribute('data-accordion-selected', selected === 'false' ? 'true' : 'false');
}

function toggleFeatureComparisonExpansion(ident) {
    let scrollBottomOffset = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;

    let comparisonTable = document.getElementById(ident);
    let expanded = comparisonTable.getAttribute('data-feature-list-expanded') === 'true';
    if (expanded) {
        comparisonTable.setAttribute('data-feature-list-expanded', 'false');
        window.scrollTo({
            top: document.documentElement.scrollHeight - window.innerHeight - scrollBottomOffset,
            behavior: 'instant'
        });
    } else {
        comparisonTable.setAttribute('data-feature-list-expanded', 'true');
    }
}
